export const getEventBaseId = (event) => (
  event?.event_uuid ||
  event?.eventUuid ||
  event?.uuid ||
  event?.id ||
  ''
);

export const getEventOccurrenceKey = (event, fallback = '') => {
  const eventId = getEventBaseId(event);
  if (!eventId && !fallback) return '';
  const performanceId =
    event?.display_performance_id ??
    event?.performance_id ??
    event?.event_performance_id ??
    event?.display_performance_sort_order ??
    event?.performance_sort_order ??
    event?.performanceTypeId;
  const parts = [
    eventId || 'event',
    performanceId,
    event?.calendar_date_key,
    event?.event_date,
    event?.start_time,
    fallback,
  ].filter((part) => part !== undefined && part !== null && part !== '');
  return parts.map((part) => String(part)).join(':');
};

export default getEventOccurrenceKey;
